import TourProductObjectValue from '../ObjectValue/TourProduct';

const TourProductsRepository = Backbone.Collection.extend({
    model: TourProductObjectValue,
});

export default TourProductsRepository;